export const CANVAS_ZOOMED_VIEW_EXPERIMENT = {
	name: 'canvas_zoomed_view',
	control: 'control',
	variant: 'variant',
};

export const NDV_IN_FOCUS_PANEL_EXPERIMENT = {
	name: 'ndv_in_focus_panel',
	control: 'control',
	variant: 'variant',
};

export const COMMAND_BAR_EXPERIMENT = {
	name: 'command_bar',
	control: 'control',
	variant: 'variant',
};

export const NDV_UI_OVERHAUL_EXPERIMENT = {
	name: '029_ndv_ui_overhaul',
	control: 'control',
	variant: 'variant',
};

export const EXTRA_TEMPLATE_LINKS_EXPERIMENT = {
	name: '034_extra_template_links',
	control: 'control',
	variant: 'variant',
};

export const TEMPLATE_ONBOARDING_EXPERIMENT = {
	name: '035_template_onboarding',
	control: 'control',
	variantStarterPack: 'variant-starter-pack',
	variantSuggestedTemplates: 'variant-suggested-templates',
};

export const BATCH_11AUG_EXPERIMENT = {
	name: '37_onboarding_experiments_batch_aug11',
	control: 'control',
	variantReadyToRun: 'variant-ready-to-run-workflows',
	variantReadyToRun2: 'variant-ready-to-run-workflows_v2',
	variantReadyToRun3: 'variant-ready-to-run-workflows_v3',
};

export const PRE_BUILT_AGENTS_EXPERIMENT = {
	name: '038_pre_built_agents',
	control: 'control',
	variant: 'variant',
};

export const TEMPLATE_RECO_V2 = {
	name: '039_template_onboarding_v2',
	control: 'control',
	variant: 'variant',
};

export const TEMPLATES_DATA_QUALITY_EXPERIMENT = {
	name: '046_templates_data_quality',
	control: 'control',
	variant1: 'variant-batch-1',
	variant2: 'variant-batch-2',
	variant3: 'variant-batch-3',
};

export const READY_TO_RUN_V2_EXPERIMENT = {
	name: '042_ready-to-run-worfklow_v2',
	control: 'control',
	variant1: 'variant-1-singlebox',
	variant2: 'variant-2-twoboxes',
};

export const READY_TO_RUN_V2_PART2_EXPERIMENT = {
	name: '045_ready-to-run-worfklow_v2-2',
	control: 'control',
	variant3: 'variant-3',
	variant4: 'variant-4',
};

export const PERSONALIZED_TEMPLATES_V3 = {
	name: '044_template_reco_v3',
	control: 'control',
	variant: 'variant',
};

export const TIME_SAVED_NODE_EXPERIMENT = {
	name: '053_time_saved_node',
};

export const TEMPLATE_SETUP_EXPERIENCE = {
	name: '055_template_setup_experience',
	control: 'control',
	variant: 'variant',
};

export const AI_BUILDER_TEMPLATE_EXAMPLES_EXPERIMENT = {
	name: '056_ai_builder_template_examples',
	control: 'control',
	variant: 'variant',
};

export const AI_BUILDER_MULTI_AGENT_EXPERIMENT = {
	name: '057_ai_builder_multi_agent',
	control: 'control',
	variant: 'variant',
};

export const EXPERIMENTS_TO_TRACK = [
	EXTRA_TEMPLATE_LINKS_EXPERIMENT.name,
	TEMPLATE_ONBOARDING_EXPERIMENT.name,
	NDV_UI_OVERHAUL_EXPERIMENT.name,
	BATCH_11AUG_EXPERIMENT.name,
	PRE_BUILT_AGENTS_EXPERIMENT.name,
	TEMPLATE_RECO_V2.name,
	TEMPLATES_DATA_QUALITY_EXPERIMENT.name,
	READY_TO_RUN_V2_PART2_EXPERIMENT.name,
	AI_BUILDER_TEMPLATE_EXAMPLES_EXPERIMENT.name,
	AI_BUILDER_MULTI_AGENT_EXPERIMENT.name,
	TIME_SAVED_NODE_EXPERIMENT.name,
	TEMPLATE_SETUP_EXPERIENCE.name,
];
